import React, { useState } from 'react'
import "./ProfileCard.css"
import { useSelector,useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import img from "../../images/profileImage.jpg"
import { UserEdit } from '../../features/User/UserAction';



export default function ProfieCard({ setAdClick, adClick }) {
  const dispatch = useDispatch();
  const { BookWormUser } = useSelector((state) => state);
  const { userInfo } = BookWormUser;
  const navigate = useNavigate();

  const [user,setUser] = useState({name:userInfo.name,email:userInfo.email,contact:userInfo.contact,location:userInfo.location,id:userInfo._id});
  const [address,setAddress] = useState({streetAddress:'',city:'',state:'',pincode:''});
  const changeUser = (e)=>{
      setUser({...user, [e.target.name] : e.target.value});
  }
  const onAddresschange = (e)=>{
    setAddress({...address,[e.target.name]:e.target.value});
}

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(UserEdit({user,address}))
  }

  return (
      <div className="profileCard">
          
        <img src={img} className='profileImg' alt="" />
        <div className="profileText">
              <h1>{userInfo.name}</h1>
              <span className='edit-profile' data-bs-toggle="modal" data-bs-target="#exampleModal" ><i className="fa-solid fa-user-pen" /> Edit Profile</span> 
              <div className="profileBtns">  
                <button className='btn viewAdBtn' onClick={()=>setAdClick(!adClick)} >{ adClick ? "View My ProfileInfo" : "View My Ads" } </button>
                <button className='btn viewAdBtn' onClick={()=>{navigate("./notification")}}>My Notificaions </button>
                <button className='btn viewAdBtn' onClick={() => {navigate("../cart")}}>My Cart <i className ="fa-solid fa-cart-shopping"></i> </button>
              </div>
        </div>
        <div className="AdsInfo">
            <div className="sold AdsInfoCard">
           <p>{ userInfo.ads ? userInfo.ads.sold.length : 0}</p>
                <span>AD SOLD</span>
            </div>
            <div className="unapproved AdsInfoCard">
            <p>{  userInfo.ads ? userInfo.ads.pending.length + userInfo.ads.negotiation.length : 0 } </p>
                <span>AD Unapprooved</span>
            </div>
            <div className="approved AdsInfoCard">
            <p>{ userInfo.ads ? userInfo.ads.approved.length : 0}</p>
                <span>AD approoved</span>
            </div>
        </div>

        {/* <!-- Modal --> */}
        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Edit Your Profile !</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className='editModal-container'>
                  <form >
                      <div className='ad-form-comp'>
                          <label>Name</label>
                          <input type="text" className='edit-input' name='name' onChange={changeUser} value={user.name}/>
                      </div>
                      <div className='ad-form-comp'>
                          <label>Email</label>
                          <input type="text" className='edit-input' name='email' onChange={changeUser} value={user.email}/>
                      </div>
                      <div className='ad-form-comp'>
                          <label>Contact</label>
                          <input type="text" className='edit-input' name='contact' onChange={changeUser} value={user.contact}/>
                      </div>
                      <div className='ad-form-comp'>
                          <label>Location</label>
                          <input type="text" className='edit-input' name='location' onChange={changeUser} value={user.location}/>
                      </div>

                      <hr />
                      <h4>Shipping Address</h4>

                      <div className='ad-form-comp'>
                          <label>Street Address</label>
                          <input className="form-control" type="text" placeholder="Apartment / Locality" name='streetAddress' onChange={onAddresschange} value={address.streetAddress}></input>
                      </div>
                      <div className='ad-form-comp'>
                          <label>City</label>
                          <input className="form-control" type="text" placeholder="" name='city' onChange={onAddresschange} value={address.city}></input>
                      </div>
                      <div className='ad-form-comp'>
                          <label>State</label>
                          <input className="form-control" type="text" placeholder="" name='state' onChange={onAddresschange} value={address.state}></input>
                      </div>
                      <div className='ad-form-comp'>
                          <label>Area Pincode</label>
                          <input className="form-control" type="text" placeholder="" name='pincode' onChange={onAddresschange} value={address.pincode}></input>
                      </div>

                  </form>

                  
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="submit" className="btn btn-primary form-btn" onClick={handleSubmit} data-bs-dismiss="modal">Save changes</button>
              </div>
            </div>
          </div>
        </div>

      </div>
  )
}
